module.exports = __webpack_public_path__ + "assets/img/3_1357.ed8b3b9c.jpg";